
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"16","viewBox":"0 0 9 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0.329505 1.95098C-0.109835 1.50466 -0.109835 0.781048 0.329505 0.334735C0.768845 -0.111579 1.48116 -0.111579 1.9205 0.334735L8.67049 7.19188C9.09639 7.62454 9.1113 8.32121 8.7043 8.77225L2.5168 15.6294C2.09696 16.0947 1.38532 16.1261 0.927309 15.6996C0.469301 15.2731 0.43836 14.5502 0.858201 14.0849L6.31784 8.03437L0.329505 1.95098Z","fill":"currentColor"}})])
          )
        }
      }
    